export default __webpack_public_path__ + "static/payment-orchestration-small-37cdd42913dec36fd9b76f89fbe8012b.png";